import script from "./new_cursor.vue?vue&type=script&setup=true&lang=js"
export * from "./new_cursor.vue?vue&type=script&setup=true&lang=js"

import "./new_cursor.vue?vue&type=style&index=0&id=300df36c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300df36c"]])

export default __exports__